module.exports = __webpack_public_path__ + "img/logoWhite.f53aa977.svg";